<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 add-l-inputs">
      <h6>Please fill out the below fields to add a new location</h6>
      <md-field>
        <label>Name of Location</label>
        <md-input type="text" v-model="newLocation.name"></md-input>
      </md-field>
      <md-field>
        <label>Upload Images of Scan Site</label>
        <md-file @change="cool($event.target.files)" v-model="newLocation.files" multiple></md-file>
      </md-field>
      <md-field>
        <label>Add Description of Scan Site</label>
        <md-textarea v-model="newLocation.description" md-autogrow></md-textarea>
      </md-field>
      <md-button class="md-success add-button" @click="addNewLocation">Add Location</md-button>
    </div>
    <!-- <div class="md-layout-item md-size-100 add-l-inputs">

    </div>
    <div class="md-layout-item md-size-100">

    </div>
    <div class="md-layout-item md-size-100 add-button">
    </div> -->
  </div>
</template>
<script>
  import api from "@/api";
  export default {
    components: {
    },
    name: 'AddLocation',
    props: [
      'showLBox',
      'projectId',
      'locationsLength'
    ],
    data() {
      return {
        responsive: false,
        newLocation: {
          ats_location_number: (this.locationsLength + 1),
          name: '',
          files: '',
          description: '',
        },
	file: false
      }
    },
    methods: {
      addNewLocationAndCloseBox(location) {
        this.$emit("childToParent", location);
      },
      onResponsiveInverted() {
        if (window.innerWidth < 768) {
          this.responsive = true;
        } else {
          this.responsive = false;
        }
      },
      cool(files) {
	this.file = files;
      },
      addNewLocation(){
        var data = {
          location: this.newLocation,
          projectId: this.projectId
        }
	var formData = new FormData();
	formData.append('name', this.newLocation.name);
	formData.append('description', this.newLocation.description);
	if ( this.file && this.file.length ) {
		this.file.forEach(f => {
			formData.append('files[]', f);
		})
	}
	formData.append('projectId', this.projectId);
        api.addNewLocation(formData).then((response) => {
          this.addNewLocationAndCloseBox(response.data.location);
        })
      }
    },
    computed: {
      simpleTimeline() {
        if (this.responsive) {
          return "simple";
        }
        return "";
      }
    },
    mounted() {
      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResponsiveInverted);
    }
  }
</script>
<style lang="scss" scoped>
  .header {
    h4 {
      margin: 0;
    }
  }
  .add-l-inputs {
    margin-top: 20px;
  }
  .add-button {
    margin: 20px auto;
    justify-content: center;
  }
</style>
